import React from 'react'
import {Navigate} from 'react-router-dom'
import {WithChildren} from '../../_metronic/helpers'
import {tenantFeatureEnabled} from './tenantState'

interface TenantFeatureRouteProps extends WithChildren {
  feature: string
}

/**
 * Route-level gate for a tenant-optional feature (a diwan entitlements-catalog
 * key surfaced in tenant-config, e.g. `daily_deals`). Pairs with the sidebar
 * menu gate: the menu hides the entry, and this makes the route unreachable by
 * deeplink too.
 *
 * A disabled feature is HIDDEN, not FORBIDDEN — so a deeplink lands quietly on
 * the home page rather than the "Access Denied" screen (which wrongly implies a
 * user-permission problem for something the tenant simply doesn't have). /dashboard
 * cascades to /permission-overview via its own RBAC gate when the user lacks it.
 *
 * FAIL-OPEN via {@link tenantFeatureEnabled}: no tenant loaded / absent flag ⇒
 * renders children exactly as today (Dumyah and un-gated tenants unaffected).
 * Compose ABOVE the user-RBAC ProtectedRoute so both gates apply.
 */
export const TenantFeatureRoute: React.FC<TenantFeatureRouteProps> = ({
  feature,
  children,
}) => {
  if (!tenantFeatureEnabled(feature)) {
    return <Navigate to='/dashboard' replace />
  }
  return <>{children}</>
}

export default TenantFeatureRoute
